module.exports = __webpack_public_path__ + "static/media/Flowchart_CS.bc06777d.jpg";